export const printMenuCross = (menuData, menuCrossWraper) => {

  /**
   * Print submenus tabs. Use a loop for that
   */
  for (let x = 0 ; x < menuData.submenus.length ; x +=1) {
    if(menuData.submenus[x].type === 'sports') {
      menuCrossWraper.append(`
      <a class="menu-item deploy" data-type="${menuData.submenus[x].data}">
        <span>${menuData.submenus[x].cat_name.toUpperCase()}</span>
      </a>`);
      if (menuData.submenus[x].url.length>1 && window.tc_vars.env_channel !== 'tablet'){
        jQuery(`.menu-item.deploy[data-type=${menuData.submenus[x].data}]`).attr('href',menuData.submenus[x].url);
      }
    } else if(menuData.submenus[x].type === 'category') {
      menuCrossWraper.append(`<a class="menu-item deploy" data-type="${menuData.submenus[x].data}">
        <span>${menuData.submenus[x].cat_name.toUpperCase()}</span></a>
     `);
      if (menuData.submenus[x].url.length>1 && window.tc_vars.env_channel !== 'tablet'){
        jQuery(`.menu-item.deploy[data-type=${menuData.submenus[x].data}]`).attr('href',menuData.submenus[x].url);
      }
    } else if(menuData.submenus[x].type === 'fdt') {
      menuCrossWraper.append(`<a class="fdt-link menu-item deploy fdt" data-type="${menuData.submenus[x].data}" href="${menuData.submenus[x].url}">
        <span>${menuData.submenus[x].cat_name.toUpperCase()}</span>
     </a>`);
    } else if(menuData.submenus[x].type === 'opeco') {
      menuCrossWraper.append(`<a href="${menuData.submenus[x].url}" class="opeco-link menu-item deploy" data-type="${menuData.submenus[x].data}">
        <span>${menuData.submenus[x].cat_name.toUpperCase()}</span>
     </a>`);

    } else if(menuData.submenus[x].type === 'servicios') {
      menuCrossWraper.append(`<a href="${menuData.submenus[x].url}" class="servicios-link menu-item deploy" data-type="${menuData.submenus[x].data}">
        <span>${menuData.submenus[x].cat_name.toUpperCase()}</span>
     </a>`);
    }
  }

  /**
   * print the submenu tabs content. Use a loop for that
   */
  for (let x = 0 ; x < menuData.submenus.length ; x +=1) {
    if(menuData.submenus[x].type === 'sports') {
      printSportTab(menuData.submenus[x]);
    } else if(menuData.submenus[x].type === 'category') {
      printCategoryTab(menuData.submenus[x]);
    } else if(menuData.submenus[x].type === 'fdt') {
      printFdtTab(menuData.submenus[x]);
    } else if(menuData.submenus[x].type === 'opeco') {
      printOpecoTab(menuData.submenus[x]);
    } else if(menuData.submenus[x].type === 'servicios') {
      printServicesTab(menuData.submenus[x]);
    }
  }

  /**
   * @description Print sport tab. Called when the submenu type is "sports"
   * @param {object} submenu
   */
  function printSportTab(submenu) {
    menuCrossWraper.append(`
    <div id="main_sports" class="sub-menu-cross" data-type="${submenu.data}">
      <div id="all-sport">
        <div id="col0" class="column">
        </div>
      </div>
    </div>`);

    let cont = 0;
    let col = 0;
    for (let x = 0; x < submenu.sports_links.length; x += 1) {
      if ((cont + submenu.sports_links[x].sports.length) < 20) {
        cont += submenu.sports_links[x].sports.length;
        $(`#col${col}`).append(`<div class="sport-leter">${submenu.sports_links[x].leter}</div>`);
        for (let y = 0; y < submenu.sports_links[x].sports.length; y += 1) {
          $(`#col${col}`).append(`
          <div>
            <a class="link__sport__item" href="${submenu.sports_links[x].sports[y].link}">${submenu.sports_links[x].sports[y].name}</a>
          </div>`);
        }
      } else {
        col += 1;
        cont = submenu.sports_links[x].sports.length;
        jQuery(`<div id="col${col}" class="column"></div>`).insertAfter(`#col${col - 1}`);
        $(`#col${col}`).append(`<div class="sport-leter">${submenu.sports_links[x].leter}</div>`);
        for (let y = 0; y < submenu.sports_links[x].sports.length; y += 1) {
          $(`#col${col}`).append(`
          <div>
            <a class="link__sport__item" href="${submenu.sports_links[x].sports[y].link}">${submenu.sports_links[x].sports[y].name}</a>
          </div>`);
        }
      }
    }

    jQuery('#all-sport').append(`<div id="sports-categories-content">`);
    for (let y = 0 ; y < submenu.sports_lighthouse.length ; y+=1) {
      jQuery('#sports-categories-content').append(`
      <div class="content-sport">
        <a href="${submenu.sports_lighthouse[y].sport_url}">
          <img class="js-img-lazy" data-src="${submenu.sports_lighthouse[y].img_url}">
          <div class="sport-name">${submenu.sports_lighthouse[y].name}</div>
        </a>
      </div>`);
    }

  }

  /**
   * @description Print category tab. Called when the submenu type is "category"
   * @param {object} submenu
   */
  function printCategoryTab(submenu){
    
    menuCrossWraper.append(`<div class="sub-menu-cross" data-type="${submenu.data}">`);

    for (let x = 0 ; x < submenu.category_links.length ; x+=1) {
      jQuery(`.sub-menu-cross[data-type=${submenu.data}]`).append(`<div class="column"><div id="cat-${submenu.data}-${x}"></div></div>`);
      for (let y = 0 ; y < submenu.category_links[x].links.length ; y+=1) {
        jQuery(`#cat-${submenu.data}-${x}`).append(`<a class="content ${submenu.category_links[x].links[y].class}" href="${submenu.category_links[x].links[y].url}">${submenu.category_links[x].links[y].name}</a>`);
      }
    }
    
    if (submenu.category_lighthouse[0].active) {
      printTemplateOneImage(jQuery(`.sub-menu-cross[data-type=${submenu.data}]`), submenu.category_lighthouse[0].spaces, submenu);
    } else if (submenu.category_lighthouse[1].active) {
      printTemplateTwoImages(jQuery(`.sub-menu-cross[data-type=${submenu.data}]`), submenu.category_lighthouse[1].spaces, submenu);
    } else if (submenu.category_lighthouse[2].active) {
      printTemplateThreeImages(jQuery(`.sub-menu-cross[data-type=${submenu.data}]`), submenu.category_lighthouse[2].spaces);
    }

    
  }

  /**
   * @description Print end of season tab. Called when the submenu type is "fdt"
   * @param {object} submenu
   */
  function printFdtTab (submenu) {
    menuCrossWraper.append(`<div class="sub-menu-cross" data-type="${submenu.data}">`);

    for (let x = 0 ; x < submenu.category_lighthouse.length ; x+=1) {
      jQuery(`.sub-menu-cross[data-type=${submenu.data}]`).append(`
        <div class="column img-faro">
            <div class="menucross-imgfaro" data-imgfaro="">
                <a href="${submenu.category_lighthouse[x].link_url}"> <img class="js-img-lazy js-img-lazy-loaded" data-src="${submenu.category_lighthouse[x].img_url}"></a>
                <div class="imgfaro-text"><a href="${submenu.category_lighthouse[x].link_url}">${submenu.category_lighthouse[x].text}</a></div>
            </div>
        </div>`);
    }
  }

  /**
   * @description Print opeco tab. Called when the submenu type is "opeco"
   * @param {object} submenu
   */
  function printOpecoTab (submenu) {
    menuCrossWraper.append(`<div class="sub-menu-cross" data-type="${submenu.data}">`);
    for (let x = 0 ; x < submenu.category_lighthouse.length ; x+=1) {
      jQuery(`.sub-menu-cross[data-type=${submenu.data}]`).append(`
        <div class="column img-faro">
            <div class="menucross-imgfaro" data-imgfaro="">
                <a href="${submenu.category_lighthouse[x].link_url}"> <img class="js-img-lazy js-img-lazy-loaded" data-src="${submenu.category_lighthouse[x].img_url}"></a>
                <div class="imgfaro-text"><a href="${submenu.category_lighthouse[x].link_url}">${submenu.category_lighthouse[x].text}</a></div>
            </div>
        </div>`);
    }

  }

  /**
   * @description Print services tab. Called when the submenu type is "servicios"
   * @param {object} submenu
   */
  function printServicesTab (submenu) {
    menuCrossWraper.append(`<div class="sub-menu-cross" data-type="${submenu.data}">`);

    let countRows=(submenu.category_links.length/3);
    const restRows=(submenu.category_links.length%3);
    let control=1;
    let position=0;

    if (restRows>0){
      countRows=parseInt((countRows+1),10);
    }

    for (let x = 0 ; x < 3 ; x+=1) {

      jQuery(`.sub-menu-cross[data-type=${submenu.data}]`).append(`
        <div class="column-services" data-index="${x}"></div>`);
    }

    for (let x = 0 ; x < 3 ; x+=1) {
      for (let y = position ; y < submenu.category_links.length ; y+=1) {
        jQuery(`.column-services[data-index=${x}]`).append(`
        <div class="one-service"><img class="js-img-lazy" data-src="${submenu.category_links[y].img_picto}"><a href="${submenu.category_links[y].link_url}">${submenu.category_links[y].name}</a></div>`);
        if (control===countRows){
          control=1;
          position+=1;
          break;
        }else{
          control+=1;
          position+=1;
        }

      }
    }
  }

  /**
   * @description Print a template of one lighthouse image block
   * @param {dom element} wraperDomElment Dom element to append the blocks
   * @param {object} blocks Block's info
   */
  function printTemplateOneImage (wraperDomElment, blocks, submenu) {
    wraperDomElment.append(`<div id=${wraperDomElment.data('type')} class="wrapper__images"></div>`);
    $(`#${wraperDomElment.data('type')}`).append(`
    <div class="column img-faro oneImage">
      <div class="menucross-imgfaro" data-imgfaro="${blocks[0].text}">
          <a href="${blocks[0].link_url}"><img class="js-img-lazy" data-src="${blocks[0].img_url}"></a>
          <div class="imgfaro-text">
            <a href="${blocks[0].link_url}">${blocks[0].text}</a>
          </div>
      </div>
    </div>`);
    if(submenu.category_special !==undefined){
      printCategorySpecialOne(wraperDomElment,submenu.category_special);
    }
  }

  /**
   * @description Print a template of two lighthouse images blocks
   * @param {dom element} wraperDomElment Dom element to append the blocks
   * @param {object} blocks Block's info
   */
  function printTemplateTwoImages (wraperDomElment, blocks, submenu) {
    wraperDomElment.append(`<div id=${wraperDomElment.data('type')} class="wrapper__images"></div>`);
    for (let x = 0 ; x < blocks.length ; x+=1) {
      $(`#${wraperDomElment.data('type')}`).append(`
       <div class="column  columm__img img-faro twoImage">
          <div class="menucross-imgfaro" data-imgfaro="${blocks[x].text}">
              <a href="${blocks[x].link_url}"><img class="js-img-lazy" data-src="${blocks[x].img_url}"></a>
              <div class="imgfaro-text">
                <a href="${blocks[x].link_url}">${blocks[x].text}</a>
              </div>
          </div>
        </div>`);
       
    }
    if(submenu.category_special !==undefined){
      printCategorySpecial(wraperDomElment,submenu.category_special);
    }
    //if(category_special !=='' &&  wraperDomElment.data('type')===category_special.data){
    //printCategorySpecial(wraperDomElment,category_special);
    //}

    

  }

  /**
   * @description Print a template of three lighthouse images blocks
   * @param {dom element} wraperDomElment Dom element to append the blocks
   * @param {object} blocks Block's info
   */
  function printTemplateThreeImages (wraperDomElment, blocks) {
    for (let x = 0 ; x < blocks.length ; x+=1) {
      wraperDomElment.append(`
        <div class="column img-faro threeImage">
          <div class="menucross-imgfaro" data-imgfaro="${blocks[x].text}">
              <a href="${blocks[x].link_url}"><img class="js-img-lazy" data-src="${blocks[x].img_url}"></a>
              <div class="imgfaro-text">
                <a href="${blocks[x].link_url}">${blocks[x].text}</a>
              </div>
          </div>
        </div>`);
    }
  }
  /**
   * @description Print a template of category special
   * @param {dom element} wraperDomElment Dom element to append the blocks
   * @param {object} blocks Block's info
   */
  function printCategorySpecial (wraperDomElment,blocks){

    $(`#${wraperDomElment.data('type')}`).append(`
    <div id=${wraperDomElment.data('type')} class="category_special">
      <div class="item-category_title">${blocks.title}</div>
      <div class="block-special-1"></div>
      <div class="block-special-2"></div>
    </div>`);

    for(let x=0; x< blocks.categories.length; x+=1){
      if (x%2 === 0){
        $(`#${wraperDomElment.data('type')} > .category_special .block-special-1`).append(`
        <div class="item-category_special"> 
        <a href="${blocks.categories[x].link_url}">${blocks.categories[x].text}</a>
      </div>`);
      }
      else{
        $(`#${wraperDomElment.data('type')} > .category_special .block-special-2`).append(`
        <div class="item-category_special"> 
        <a href="${blocks.categories[x].link_url}">${blocks.categories[x].text}</a>
      </div>`);
      }
    }
    
  }

  function printCategorySpecialOne (wraperDomElment,blocks){
    $(`#${wraperDomElment.data('type')}`).append(`
    <div id=${wraperDomElment.data('type')} class="category_special">
      <div class="item-category_title">${blocks.title}</div>
      <div class="block-special-1"></div>
    </div>`);
    for(let x=0; x< blocks.categories.length; x+=1){
      $(`#${wraperDomElment.data('type')} > .category_special .block-special-1`).append(`
        <div class="item-category_special"> 
        <a href="${blocks.categories[x].link_url}">${blocks.categories[x].text}</a>
      </div>`);
    }
  }
  /**
   * @description Remove Links if is Tablet in OPECO-FDT-SERVICE
   */
  if (window.tc_vars.env_channel === 'tablet') {
    jQuery('.fdt-link').removeAttr('href');
    jQuery('.servicios-link').removeAttr('href');
    jQuery('.opeco-link').removeAttr('href');

  } else {
    jQuery('#menu-cross .menu-item[data-type=servicios]').on('click', () => {
      window.location = $(this).find('a').attr('href');
    });
    jQuery('#menu-cross .menu-item[data-type=fin-de-temporada]').on('click', () => {
      window.location = $(this).find('a').attr('href');
    });
    jQuery('#menu-cross .menu-item[data-type=opeco]').on('click', () => {
      window.location = $(this).find('a').attr('href');
    });
  }

};



// WEBPACK FOOTER //
// ./src/_override/shared/menu-cross/functions-print-menu-cross.js